import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import {GiftCards} from 'vexpo-components';

/** @class GiftCardsPreview
  * A component for rendering a preview of
  * the gift cards being edited.
  * @prop {string} dataURL - the url of the hall being edited
  */
export default class GiftCardPreview extends Component {
  /** @constructor
    * Creates a new instance of HallPreview
    */
  constructor(props) {
    super(props);
    this.state = {
      cards: []
    }
    this.dataURL = `/expos/${this.props.expoID}/shows/${this.props.showID}/halls/${this.props.hallID}`;
    this.dataRef = firebase.database().ref(this.dataURL);
  }
  /** @method componentWillMount
    * Connects the component to the firebase record for the hall.
    */
  componentWillMount() {
    this.dataRef.on('value', (snapshot) => {
      this.setState({cards: Object.values(snapshot)});
    });
  }
  /** @method componentWillUnmount
    * Disconnects the component from firebase
    */
  componentWillUnmount() {
    this.dataRef.off();
  }
  /** @method render
    * Renders the hall
    */
  render() {
    return <GiftCards expoID={this.props.expoID} showID={this.props.showID} deals={this.state.cards}/>
  }
}



// WEBPACK FOOTER //
// ./src/gift-cards-preview/gift-cards-preview.js